// extracted by mini-css-extract-plugin
export default {"heading":"coverage-page-module__heading--zXM"};